export const CHROME_EXTENSION_URL="https://chrome.google.com/webstore/detail/socialtribes/pacmkebjpoheiccieiabknnilmodgjjk"
export const GOOGLE_SHEET_TEMPLATE_URL = "https://docs.google.com/spreadsheets/d/1E7fJt9MKlzryLonOL9RJToZYlykxiFqGYn_xu0MJEx8/copy"
